export const menuData = {
  "Veg Ji Spl. Momos": [
    {
      name: "Steam Veg Momos",
      half: "140/-",
      full: null,
      image:
        "https://images.unsplash.com/photo-1534422298391-e4f8c172dddb?w=400",
    },
    {
      name: "Steam Paneer Momos",
      half: "190/-",
      full: null,
      image:
        "https://images.unsplash.com/photo-1534422298391-e4f8c172dddb?w=400",
    },
    {
      name: "Steam Gravy Momos",
      half: "220/-",
      full: null,
      image:
        "https://images.unsplash.com/photo-1534422298391-e4f8c172dddb?w=400",
    },
    {
      name: "Steam Chilli Momos",
      half: "220/-",
      full: null,
      image:
        "https://images.unsplash.com/photo-1534422298391-e4f8c172dddb?w=400",
    },
    {
      name: "Fried Veg Momos",
      half: "140/-",
      full: null,
      image:
        "https://images.unsplash.com/photo-1496116218417-1a781b1c416c?w=400",
    },
    {
      name: "Fried Paneer Momos",
      half: "190/-",
      full: null,
      image:
        "https://images.unsplash.com/photo-1496116218417-1a781b1c416c?w=400",
    },
    {
      name: "Tandoori Momos",
      half: "150/-",
      full: null,
      image:
        "https://images.unsplash.com/photo-1601050690597-df0568f70950?w=400",
    },
    {
      name: "Veg Tan Momos",
      half: "190/-",
      full: null,
      image:
        "https://images.unsplash.com/photo-1601050690597-df0568f70950?w=400",
    },
    {
      name: "Paneer Tan Momos",
      half: "220/-",
      full: null,
      image:
        "https://images.unsplash.com/photo-1601050690597-df0568f70950?w=400",
    },
    {
      name: "Afghani Momos",
      half: "220/-",
      full: null,
      image:
        "https://images.unsplash.com/photo-1534422298391-e4f8c172dddb?w=400",
    },
    {
      name: "Afghani Paneer Momos",
      half: "211/-",
      full: null,
      image:
        "https://images.unsplash.com/photo-1534422298391-e4f8c172dddb?w=400",
    },
    {
      name: "Kukure Paneer Momos",
      half: "290/-",
      full: null,
      image:
        "https://images.unsplash.com/photo-1496116218417-1a781b1c416c?w=400",
    },
    {
      name: "Kurkure Veg Fry Momos",
      half: "290/-",
      full: null,
      image:
        "https://images.unsplash.com/photo-1496116218417-1a781b1c416c?w=400",
    },
  ],

  Breads: [
    {
      name: "Tandoori Roti",
      half: "15/-",
      full: null,
      image:
        "https://images.unsplash.com/photo-1619365562329-265cb6f20028?w=400",
    },
    {
      name: "Butter Tandoori Roti",
      half: "20/-",
      full: null,
      image:
        "https://images.unsplash.com/photo-1619365562329-265cb6f20028?w=400",
    },
    {
      name: "Rumali Roti",
      half: "15/-",
      full: null,
      image:
        "https://images.unsplash.com/photo-1628840042765-356cda07504e?w=400",
    },
    {
      name: "Missi Roti",
      half: "40/-",
      full: null,
      image:
        "https://images.unsplash.com/photo-1628840042765-356cda07504e?w=400",
    },
    {
      name: "Plain Naan",
      half: "40/-",
      full: null,
      image:
        "https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=400",
    },
    {
      name: "Butter Naan",
      half: "50/-",
      full: null,
      image:
        "https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=400",
    },
    {
      name: "Lacha Naan",
      half: "40/-",
      full: null,
      image:
        "https://images.unsplash.com/photo-1601050690597-df0568f70950?w=400",
    },
    {
      name: "Garlic Naan",
      half: "60/-",
      full: null,
      image:
        "https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=400",
    },
    {
      name: "Aaloo Naan",
      half: "70/-",
      full: null,
      image:
        "https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=400",
    },
    {
      name: "Stuff Parantha",
      half: "70/-",
      full: null,
      image:
        "https://images.unsplash.com/photo-1628840042765-356cda07504e?w=400",
    },
    {
      name: "Stuff Naan",
      half: "70/-",
      full: null,
      image:
        "https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=400",
    },
    {
      name: "Paneer Parantha",
      half: "80/-",
      full: null,
      image:
        "https://images.unsplash.com/photo-1628840042765-356cda07504e?w=400",
    },
    {
      name: "Paneer Naan",
      half: "80/-",
      full: null,
      image:
        "https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=400",
    },
    {
      name: "Tawa Roti",
      half: "20/-",
      full: null,
      image:
        "https://images.unsplash.com/photo-1619365562329-265cb6f20028?w=400",
    },
  ],
  "Tandoori Chaap": [
    {
      name: "Afgani Chaap",
      half: "170/-",
      full: "240/-",
      image:
        "https://images.unsplash.com/photo-1599487488170-d11ec9c172f0?w=400&h=400&fit=crop",
    },
    {
      name: "Sunny Leone Chaap",
      half: "170/-",
      full: "240/-",
      image:
        "https://images.unsplash.com/photo-1626082927389-6cd097cdc6ec?w=400&h=400&fit=crop",
    },
    {
      name: "Mia Khalifa Chaap",
      half: "170/-",
      full: "240/-",
      image:
        "https://images.unsplash.com/photo-1603894584373-5ac82b2ae398?w=400&h=400&fit=crop",
    },
    {
      name: "Veg Chicken Tikka",
      half: "170/-",
      full: "240/-",
      image:
        "https://images.unsplash.com/photo-1599487488170-d11ec9c172f0?w=400&h=400&fit=crop",
    },
    {
      name: "Veg Mutton Tikka",
      half: "170/-",
      full: "240/-",
      image:
        "https://images.unsplash.com/photo-1567188040759-fb8a883dc6d8?w=400&h=400&fit=crop",
    },
    {
      name: "Veg Masala Chicken",
      half: "170/-",
      full: "240/-",
      image:
        "https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=400&h=400&fit=crop",
    },
    {
      name: "Veg Lemon Garlic Chicken",
      half: "170/-",
      full: "240/-",
      image:
        "https://images.unsplash.com/photo-1603894584373-5ac82b2ae398?w=400&h=400&fit=crop",
    },
    {
      name: "Masala Chaap",
      half: "170/-",
      full: "240/-",
      image:
        "https://images.unsplash.com/photo-1626082927389-6cd097cdc6ec?w=400&h=400&fit=crop",
    },
    {
      name: "Veg Leg Piece Tandoori",
      half: "170/-",
      full: "240/-",
      image:
        "https://images.unsplash.com/photo-1599487488170-d11ec9c172f0?w=400&h=400&fit=crop",
    },
  ],

  Chaap: [
    {
      name: "Malai Chaap",
      half: "160/-",
      full: "240/-",
      image:
        "https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=400&h=400&fit=crop",
    },
    {
      name: "Punjabi Chaap",
      half: "160/-",
      full: "240/-",
      image:
        "https://images.unsplash.com/photo-1626082927389-6cd097cdc6ec?w=400&h=400&fit=crop",
    },
    {
      name: "Lemon Chaap",
      half: "160/-",
      full: "240/-",
      image:
        "https://images.unsplash.com/photo-1603894584373-5ac82b2ae398?w=400&h=400&fit=crop",
    },
    {
      name: "Garlic Chaap",
      half: "160/-",
      full: "240/-",
      image:
        "https://images.unsplash.com/photo-1567188040759-fb8a883dc6d8?w=400&h=400&fit=crop",
    },
    {
      name: "Achari Chaap",
      half: "160/-",
      full: "240/-",
      image:
        "https://images.unsplash.com/photo-1626082927389-6cd097cdc6ec?w=400&h=400&fit=crop",
    },
  ],

  "Gravy Chaap": [
    {
      name: "Veg Mutton Gravy",
      half: "160/-",
      full: "270/-",
      image:
        "https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=400&h=400&fit=crop",
    },
    {
      name: "Veg Rogan Josh",
      half: "160/-",
      full: "270/-",
      image:
        "https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=400&h=400&fit=crop",
    },
    {
      name: "Veg Rara Meat",
      half: "160/-",
      full: "270/-",
      image:
        "https://images.unsplash.com/photo-1626082927389-6cd097cdc6ec?w=400&h=400&fit=crop",
    },
    {
      name: "Veg Tawa Chicken",
      half: "160/-",
      full: "270/-",
      image:
        "https://images.unsplash.com/photo-1567188040759-fb8a883dc6d8?w=400&h=400&fit=crop",
    },
    {
      name: "Veg Butter Chicken",
      half: "160/-",
      full: "270/-",
      image:
        "https://images.unsplash.com/photo-1603894584373-5ac82b2ae398?w=400&h=400&fit=crop",
    },
    {
      name: "Veg Kadai Chicken",
      half: "160/-",
      full: "270/-",
      image:
        "https://images.unsplash.com/photo-1626082927389-6cd097cdc6ec?w=400&h=400&fit=crop",
    },
    {
      name: "Veg Handi Chicken",
      half: "160/-",
      full: "270/-",
      image:
        "https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=400&h=400&fit=crop",
    },
    {
      name: "Veg Beli Chicken",
      half: "160/-",
      full: "270/-",
      image:
        "https://images.unsplash.com/photo-1626082927389-6cd097cdc6ec?w=400&h=400&fit=crop",
    },
  ],

  "Tandoori Chaap Roll": [
    {
      name: "Shawarma Roll",
      half: "120/-",
      full: "200/-",
      image:
        "https://images.unsplash.com/photo-1529006557810-274b9b2fc783?w=400&h=400&fit=crop",
    },
    {
      name: "Veg Mutton Kabab Roll",
      half: "120/-",
      full: "200/-",
      image:
        "https://images.unsplash.com/photo-1626082927389-6cd097cdc6ec?w=400&h=400&fit=crop",
    },
    {
      name: "Malai Chaap Roll",
      half: "120/-",
      full: "200/-",
      image:
        "https://images.unsplash.com/photo-1593759608149-dec429374532?w=400&h=400&fit=crop",
    },
    {
      name: "Afghani Chaap Roll",
      half: "120/-",
      full: "200/-",
      image:
        "https://images.unsplash.com/photo-1593759608149-dec429374532?w=400&h=400&fit=crop",
    },
    {
      name: "Punjabi Chaap Roll",
      half: "120/-",
      full: "200/-",
      image:
        "https://images.unsplash.com/photo-1593759608149-dec429374532?w=400&h=400&fit=crop",
    },
  ],

  "Paneer Dishes": [
    {
      name: "Shahi Paneer",
      half: "140/-",
      full: "210/-",
      image:
        "https://images.unsplash.com/photo-1631452180519-c014fe946bc7?w=400&h=400&fit=crop",
    },
    {
      name: "Matar Paneer",
      half: "140/-",
      full: "210/-",
      image:
        "https://images.unsplash.com/photo-1631452180519-c014fe946bc7?w=400&h=400&fit=crop",
    },
    {
      name: "Kadai Paneer",
      half: "160/-",
      full: "240/-",
      image:
        "https://images.unsplash.com/photo-1631452180519-c014fe946bc7?w=400&h=400&fit=crop",
    },
    {
      name: "Paneer Butter Masala",
      half: "170/-",
      full: "270/-",
      image:
        "https://images.unsplash.com/photo-1601050690597-df0568f70950?w=400&h=400&fit=crop",
    },
    {
      name: "Paneer Tikka Masala",
      half: "170/-",
      full: "270/-",
      image:
        "https://images.unsplash.com/photo-1567188040759-fb8a883dc6d8?w=400&h=400&fit=crop",
    },
  ],

  Chinese: [
    {
      name: "French Fries",
      price: "80/-",
      image:
        "https://images.unsplash.com/photo-1573080496219-bb080dd4f877?w=400&h=400&fit=crop",
    },
    {
      name: "Chilli Potato",
      price: "90/-",
      image:
        "https://images.unsplash.com/photo-1606491956689-2ea866880c84?w=400&h=400&fit=crop",
    },
    {
      name: "Honey Chilli Potato",
      price: "120/-",
      image:
        "https://images.unsplash.com/photo-1606491956689-2ea866880c84?w=400&h=400&fit=crop",
    },
    {
      name: "Veg Chilli Chicken Dry",
      price: "220/-",
      image:
        "https://images.unsplash.com/photo-1626082927389-6cd097cdc6ec?w=400&h=400&fit=crop",
    },
    {
      name: "Chilli Paneer Gravy",
      price: "200/-",
      image:
        "https://images.unsplash.com/photo-1631452180519-c014fe946bc7?w=400&h=400&fit=crop",
    },
  ],
  "Chatkara Chaska": [
    {
      name: "Veg Chatkara Chicken",
      half: "170/-",
      full: "280/-",
      image:
        "https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=400&h=400&fit=crop",
    },
    {
      name: "Veg Buri Khalifa Gravy",
      half: "170/-",
      full: "280/-",
      image:
        "https://images.unsplash.com/photo-1626082927389-6cd097cdc6ec?w=400&h=400&fit=crop",
    },
    {
      name: "Veg Tawa Chaap",
      half: "170/-",
      full: "280/-",
      image:
        "https://images.unsplash.com/photo-1567188040759-fb8a883dc6d8?w=400&h=400&fit=crop",
    },
    {
      name: "Veg Korma Chaap",
      half: "170/-",
      full: "280/-",
      image:
        "https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=400&h=400&fit=crop",
    },
  ],
  "Veg Fry Dry": [
    {
      name: "Veg Mutton Kabab",
      half: "170/-",
      full: "250/-",
      image:
        "https://images.unsplash.com/photo-1599487488170-d11ec9c172f0?w=400&h=400&fit=crop",
    },
    {
      name: "Veg Baby Doll",
      half: "170/-",
      full: "250/-",
      image:
        "https://images.unsplash.com/photo-1626082927389-6cd097cdc6ec?w=400&h=400&fit=crop",
    },
    {
      name: "Veg KFC Crispy Chaap",
      half: "170/-",
      full: "250/-",
      image:
        "https://images.unsplash.com/photo-1603894584373-5ac82b2ae398?w=400&h=400&fit=crop",
    },
    {
      name: "Veg Chicken Popcorn",
      half: "170/-",
      full: "250/-",
      image:
        "https://images.unsplash.com/photo-1562376552-0d160a2f238d?w=400&h=400&fit=crop",
    },
    {
      name: "Veg Mutton Tikka",
      half: "170/-",
      full: "250/-",
      image:
        "https://images.unsplash.com/photo-1599487488170-d11ec9c172f0?w=400&h=400&fit=crop",
    },
    {
      name: "Veg Chicken Nugget",
      half: "170/-",
      full: "250/-",
      image:
        "https://images.unsplash.com/photo-1562376552-0d160a2f238d?w=400&h=400&fit=crop",
    },
  ],
  Tadka: [
    {
      name: "Dal Tadka",
      price: "110/-",
      image:
        "https://images.unsplash.com/photo-1546833999-b9f581a1996d?w=400&h=400&fit=crop",
    },
    {
      name: "Dal Makhani",
      price: "120/-",
      image:
        "https://images.unsplash.com/photo-1546833999-b9f581a1996d?w=400&h=400&fit=crop",
    },
    {
      name: "Nutri Kulcha",
      price: "200/-",
      image:
        "https://images.unsplash.com/photo-1628840042765-356cda07504e?w=400&h=400&fit=crop",
    },
  ],
};
